import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '../../app/store';

// Define a type for the slice state
interface LoaderState {
    value: number;
}

// Define the initial state using that type
const initialState: LoaderState = {
    value: 0,
};

export const loaderSlice = createSlice({
    name: 'loader',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.value++;
        },
        stopLoading: (state) => {
            if (!state.value) {
                return;
            }
            state.value--;
        },
    },
});

export const { startLoading, stopLoading } = loaderSlice.actions;

export const selectLoading = (state: RootState): boolean => 0 < state.loader.value;

export const LoaderReducer = loaderSlice.reducer;
